import { useCallback } from 'react';
import { Player } from 'components/CamPlayerKbygRewinds/usePlayerState/usePlayerState';

interface UsePlayPauseControlsProps {
  playing: boolean;
  pauseRewind: () => void;
  playRewind: () => void;
  pauseLive: () => void;
  playLive: () => void;
  currentPlayerRef: React.MutableRefObject<Player>;
}

const usePlayPauseControls = ({
  playing,
  pauseRewind,
  playRewind,
  pauseLive,
  playLive,
  currentPlayerRef,
}: UsePlayPauseControlsProps) => {
  const playCurrentPlayer = useCallback(() => {
    if (currentPlayerRef.current === Player.LIVE) {
      playLive();
    } else if (currentPlayerRef.current === Player.REWIND) {
      playRewind();
    }
  }, [currentPlayerRef, playLive, playRewind]);

  const pauseCurrentPlayer = useCallback(() => {
    if (currentPlayerRef.current === Player.LIVE) {
      pauseLive();
    } else if (currentPlayerRef.current === Player.REWIND) {
      pauseRewind();
    }
  }, [currentPlayerRef, pauseRewind, pauseLive]);

  const togglePlayPause = useCallback(
    (event: Event | React.MouseEvent) => {
      event.stopPropagation();
      if (playing) {
        pauseCurrentPlayer();
      } else {
        playCurrentPlayer();
      }
    },
    [pauseCurrentPlayer, playCurrentPlayer, playing],
  );

  const pauseAllPlayers = useCallback(() => {
    pauseLive();
    pauseRewind();
  }, [pauseLive, pauseRewind]);

  return {
    togglePlayPause,
    pauseAllPlayers,
    playCurrentPlayer,
    pauseCurrentPlayer,
  };
};

export default usePlayPauseControls;
